import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, flatMap, map, switchMap, tap, mergeMap } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../../user-info';
import { UserSettingService } from '../user-setting.service';
import * as UserSettingActions from './user-setting.actions';

@Injectable()
export class UserSettingEffects {
    // Comment out this effect as it clears all user settings including TemporaryPassword
    // when getUserSettings is called, which prevents localStorage persistence
    // clearUserSettings$ = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(UserSettingActions.getUserSettings),
    //         map(() => UserSettingActions.clearUserSettings())
    //     );
    // });
    getUserSettings$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserSettingActions.getUserSettings),
            tap(a =>
                this.log.verbose({
                    type: 'UserSettingEffects:getUserSettings$',
                    a
                })
            ),
            mergeMap(a =>
                this.service.get(a.EmployeeListID, a.EmpSettingID).pipe(
                    concatMap(userSettings =>
                        //need to check here if a.EmpSettingid is not set, if it is not set, then we do a load, otherwise we need to upsert
                        userSettings
                            ? [
                                a.EmpSettingID ? UserSettingActions.upsertUserSettings({
                                    userSettings
                                }) : UserSettingActions.loadUserSettings({
                                    userSettings
                                })
                              ]
                            : [
                                  fromShared.Errors.handleNullDataError(
                                      userSettings,
                                      'User Settings'
                                  )
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putUserSetting$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserSettingActions.putUserSettings),
            switchMap(a =>
                this.service.put(a.settings).pipe(
                    flatMap(resp => {
                        // Copy StatusType to ErrorMessages if ErrorMessages is empty
                        if (resp.ErrorMessages && resp.ErrorMessages.length === 0 && resp.StatusType) {
                            resp.ErrorMessages = [resp.StatusType];
                        }
                        
                        // Store ErrorMessages in sessionStorage for feature component access
                        sessionStorage.setItem("userSettingsErrorMessages", JSON.stringify(resp.ErrorMessages));

                        // Check if Items array has valid data before accessing
                        if (resp.Items && resp.Items.length > 0 && resp.Items[0]) {
                            sessionStorage.setItem("userSettingsResponseStatusCode", JSON.stringify(resp.Items[0].Status?.StatusCode || resp.StatusCode));
                            sessionStorage.setItem("userSettingsResponseMessage", JSON.stringify(resp.Items[0].Status?.Message || ''));
                        } else {
                            // Fallback to response status code if no items
                            sessionStorage.setItem("userSettingsResponseStatusCode", JSON.stringify(resp.StatusCode));
                            sessionStorage.setItem("userSettingsResponseMessage", JSON.stringify(''));
                        }
                        return fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  UserSettingActions.upsertUserSettings({
                                      userSettings: resp.Items.filter(
                                          x => x.CtrlType
                                      )
                                  }),
                                  a.settings.findIndex(x => x.EmpSettingID == 31.0) != -1
                                  ?
                                    UserSettingActions.getUserSettings({
                                        EmployeeListID: resp.Items[0]?.EmployeeListID || '',
                                        EmpSettingID: 31
                                    })
                                  :
                                                                      new fromUser.LoadUserColors(
                                    resp.Items[0]?.EmployeeListID || ''
                                  ),

                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          x =>
                                              x.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(x => x.EmpSettingType.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  UserSettingActions.upsertUserSettings({
                                      userSettings: resp.Items.filter(
                                          x => x.CtrlType
                                      )
                                  }),
                                  new fromUser.LoadUserColors(
                                      resp.Items[0]?.EmployeeListID || ''
                                  )
                              ]
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    constructor(
        private log: LoggingService,
        private actions$: Actions,
        private service: UserSettingService
    ) {}
}
